var _defs, _g, _path, _polygon, _g2, _circle, _path2, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _rect, _g10, _g11, _g12, _polygon2, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoworkingbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMin slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .coworking_before_svg__cls-3{fill:#343a50}.coworking_before_svg__cls-21,.coworking_before_svg__cls-37{fill:#fff}.coworking_before_svg__cls-19,.coworking_before_svg__cls-20,.coworking_before_svg__cls-21,.coworking_before_svg__cls-24,.coworking_before_svg__cls-28,.coworking_before_svg__cls-33,.coworking_before_svg__cls-37,.coworking_before_svg__cls-42,.coworking_before_svg__cls-45,.coworking_before_svg__cls-46,.coworking_before_svg__cls-47{stroke:#343a50}.coworking_before_svg__cls-19,.coworking_before_svg__cls-20,.coworking_before_svg__cls-21,.coworking_before_svg__cls-28,.coworking_before_svg__cls-33,.coworking_before_svg__cls-37,.coworking_before_svg__cls-45,.coworking_before_svg__cls-46,.coworking_before_svg__cls-47{stroke-miterlimit:10}.coworking_before_svg__cls-49{fill:#89bb21}.coworking_before_svg__cls-28,.coworking_before_svg__cls-37,.coworking_before_svg__cls-42,.coworking_before_svg__cls-45,.coworking_before_svg__cls-46{stroke-width:2px}.coworking_before_svg__cls-12,.coworking_before_svg__cls-42{fill:#dedede}.coworking_before_svg__cls-11{mix-blend-mode:multiply}.coworking_before_svg__cls-20{fill:#404040}.coworking_before_svg__cls-19,.coworking_before_svg__cls-33{fill:#6e8ca6}.coworking_before_svg__cls-19{stroke-width:1.8px}.coworking_before_svg__cls-20,.coworking_before_svg__cls-21,.coworking_before_svg__cls-24,.coworking_before_svg__cls-33{stroke-width:3px}.coworking_before_svg__cls-24{fill:#ffccb5}.coworking_before_svg__cls-24,.coworking_before_svg__cls-42{stroke-linecap:round;stroke-linejoin:round}.coworking_before_svg__cls-28{fill:#212121}.coworking_before_svg__cls-39{fill:#eb9a6b}.coworking_before_svg__cls-41{fill:#c67b55}.coworking_before_svg__cls-45{fill:#aa2020}.coworking_before_svg__cls-46{fill:#424242}.coworking_before_svg__cls-47{fill:#c62a2b;stroke-width:1.58px}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Coworking_Vorher"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Himmel"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5d1d6",
    points: "-1 227.82 -1 -1 333.21 -1 331.13 227.82 -1 227.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.2 0l-2.07 226.82H0V0h332.2m2-2H-2v230.82h334.12v-2L334.2 0v-2z",
    className: "coworking_before_svg__cls-3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "coworking_before_svg__Wolkem",
    fill: "#fff",
    d: "M235.87 40.68c6.72-15.77 23.7-27 43.75-27 19.81 0 36.67 11 43.55 26.46a35.74 35.74 0 018.83-1.26c18.1 0 32.76 13.07 32.76 29.2S350.13 97.29 332 97.29h-85.14c-18.09 0-32.75-13.08-32.75-29.21 0-12.67 9.11-23.35 21.76-27.4z",
    opacity: 0.32
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "coworking_before_svg__Wiese",
    fill: "#a9bf5c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "-1 587.04 1259.01 587.04 1259.01 227.1 -1 226.82 -1 587.04"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__B\\xFCrgersteig"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 140.55,
    x: -1,
    y: 586.04,
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 587v138.6H0V587h1258m2-2H-2v142.6h1262V585z",
    className: "coworking_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1260.04,
    height: 20.75,
    x: -1.04,
    y: 726.61,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 727.61v18.75H0v-18.75h1258m2-2H-2v22.75h1262v-22.75z",
    className: "coworking_before_svg__cls-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Baum"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.77,
    cy: 175.93,
    r: 125.36,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.8 178.32A125.37 125.37 0 01173.16 53c2.87 0 5.71.11 8.53.3A125.36 125.36 0 10147.24 301 125.4 125.4 0 0147.8 178.32z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#dedede"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M139.06 542.74a6 6 0 01-4.32-1.85 5.61 5.61 0 01-1.57-4.21l10.72-156.29-32-38.32a2.44 2.44 0 01-.36-2.65 2.48 2.48 0 013.67-1.06l30.23 19.89 7.77-113.17-22.76-22.81a1.69 1.69 0 01-.38-1.89 1.73 1.73 0 011.6-1.09 1.71 1.71 0 01.77.18L154.21 230l3-43.87.18-3.46a5.65 5.65 0 0111.28-.21l2 27.63 21.62-11.43h.15a3.31 3.31 0 012.58 5.89l-22.44 16.21 20.11 315.74a5.64 5.64 0 01-1.48 4.32 6 6 0 01-4.4 1.93z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.06 178.32a4.49 4.49 0 014.63 4.25l2.14 29.14 22.82-12.07a2.25 2.25 0 01.44 0 2.31 2.31 0 011.36 4.15l-22.86 16.51 20.14 316.3a4.82 4.82 0 01-4.88 5.18h-47.79a4.85 4.85 0 01-4.9-5l10.76-156.67-32.28-38.63a1.52 1.52 0 011.15-2.5 1.55 1.55 0 01.84.26L146.29 360l7.92-115.34-23.08-23.13a.74.74 0 01.51-1.27.73.73 0 01.34.08l23.13 11.19 3.11-45.34.18-3.48a4.51 4.51 0 014.66-4.42m0-2a6.52 6.52 0 00-6.66 6.31l-.18 3.48-2.9 42.36-20.47-9.9a2.72 2.72 0 00-1.21-.28 2.75 2.75 0 00-1.93 4.69l22.44 22.48-7.62 111-28.8-19a3.49 3.49 0 00-5.13 1.57 3.47 3.47 0 00.5 3.72l31.77 38-10.7 155.87a6.66 6.66 0 001.84 5 7 7 0 005.05 2.16h47.79a7 7 0 005.13-2.25 6.7 6.7 0 001.74-5.11l-20.07-315.15 22-15.87a4.31 4.31 0 00-2.53-7.77 4.11 4.11 0 00-.78.07l-.31.05-.28.15-20.15 10.64-1.92-26.09a6.47 6.47 0 00-6.62-6.1z",
    className: "coworking_before_svg__cls-3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "coworking_before_svg__cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 214.12l25.1-13.28a2.25 2.25 0 00-2.45-1.2l-22.82 12.07zM159.69 233.77l3.25-47.55.18-3.48a4.44 4.44 0 012.3-3.82 4.67 4.67 0 00-7 3.82l-.18 3.48-3.1 45.34zM138.89 536.73l20-292-21.77-21.82-5.18-2.5a.74.74 0 00-.85 1.19l23.08 23.13-8.59 125.17-11.42 166.83a4.85 4.85 0 004.9 5h4.72a4.83 4.83 0 01-4.89-5z",
    className: "coworking_before_svg__cls-12"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1261,
    height: 336.64,
    x: -1.54,
    y: 744.86,
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 746.36V1080H0V746.36h1258m3-3H-3V1083h1264V743.36z",
    className: "coworking_before_svg__cls-3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Auto_blau"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.71,
    cy: 858.87,
    r: 77.24,
    fill: "#404040",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.24,
    d: "M109.71 799.92a59 59 0 1059 59 59 59 0 00-59-59zM154 841.61l-24.79 6.19a22.19 22.19 0 00-4.78-5.87q-.81-.69-1.65-1.29l11.38-22.52A47.78 47.78 0 01154 841.61zm-91.48 22.82a48.54 48.54 0 01-.33-5.56 47.19 47.19 0 015.17-21.52l21.12 14.34a22.05 22.05 0 00-1.18 6.56zm62.09-50.68l-11.6 23a22 22 0 00-6-.07l-7-24.29a47.56 47.56 0 0124.62 1.4zM90 815.63l7.12 24.69a22.1 22.1 0 00-3.09 2.5l-21-14.23A47.74 47.74 0 0190 815.63zm-25.15 59l24.58-6.14a22.08 22.08 0 004.36 6.17l-11.6 22.94a47.76 47.76 0 01-17.3-22.96zm26.49 28.08l11.38-22.52a22.37 22.37 0 006.21 1.08l7.15 24.73a47.19 47.19 0 01-24.7-3.24zm34.87.7l-7-24.26a22.43 22.43 0 004.95-3.21l21.11 14.34a47.47 47.47 0 01-19.02 13.14zm25.11-21.69l-21-14.23a22.41 22.41 0 001.7-9.63l24.6-6.14a48 48 0 01.54 7.14 47.22 47.22 0 01-5.8 22.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353454",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.24,
    d: "M266.52 804.84c-2.61-4.61-9-7.29-16.25-6.74-.41-.33-1.05-.86-1.8-1.54-15-13.58-15.55-35.4-16-41.83-1.45-22.16-13.23-42.14-28.51-68C170.67 630.18 79.09 619-6.56 608.53c-14.24-1.74-24-2.48-39.54-3.67 0 0-104.48-8-223.43 10.11a96.4 96.4 0 00-19.08 4.83 97.55 97.55 0 00-23.45 12.41c-22.05 15.59-46.68 27.18-69.65 41.38-28.67 17.71-46 27.11-56.71 32.61-1.1-.08-2.2-.15-3.28-.2-10.19-.5-19.18-.26-69.65 5.51-37 4.23-55.49 6.35-71.72 9-7.3 1.18-28.11 5.25-69.65 13.79 0 0-6.79 1.89-42.76 11a61.34 61.34 0 00-11.72 4.13 60 60 0 00-13.79 9c-9.43 8.37-12.43 20.26-15.17 31.72a136.74 136.74 0 00-3.45 40c.48 8 4.23 21.91 11.72 49.65a32.88 32.88 0 004 9.25 30.08 30.08 0 002.18 3c18.23 2.06 28 1 39.67.58a258.8 258.8 0 0036.75-3.63c3.79-.68 6.95-1.34 9.2-1.84a112.45 112.45 0 01.3-39.53c1.65-8.78 5.37-27.32 19.92-45.37a91.2 91.2 0 0125.75-22.06c26.31-14.63 52.58-10.46 61.6-8.89s27.14 5 44.14 19.61a85.25 85.25 0 0122.37 31c7.53 18 7.63 36.36 7.66 43.22 0 2.92-.06 12.41.92 25.43.23 3 .46 5.47.62 7 11.74 2.5 427.43-.4 479.35 1.54q.66-4.87 1.22-9.91c1.7-15.37 1.52-23 2.15-30.55.51-6.1 1.63-19.59 8.12-33.71a86.35 86.35 0 0124.37-30.67c6.32-5 21.15-16.57 42.75-18.39 28.15-2.38 48.81 13.3 57.93 20.23a101.23 101.23 0 0132.64 42.75 99.3 99.3 0 016.43 45.51c4.23-.62 7.61-1.09 9.66-1.38.2 0 7-1 34.79-6.58a12.21 12.21 0 006.13-2.76c2.31-2.11 3.11-4.86 4.29-10.42 1.36-6.44 2.09-11.32 2.14-11.65 1.22-8.06 1.37-6.77 4.6-25.13.68-3.9 1.22-7 1.53-8.89a4.07 4.07 0 001.53-.92c.49-.47 1.26-1.46 1.38-4a16 16 0 00-1.68-7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcb042",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.24,
    d: "M232.5 754.73a74.31 74.31 0 00-1.42-10.31c-11.37 2.69-19.73 11.7-19.73 22.4 0 12.83 12 23.23 26.83 23.23a30.48 30.48 0 004.31-.3c-9.2-13.15-9.64-29.58-9.99-35.02z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -441.07,
    x2: 26.54,
    y1: 900.05,
    y2: 899.09,
    fill: "#b01928",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-65.87 645.77q-1.27 31.44-1.38 63.9v8.74c15.53-.59 28.08-.82 36.32-.92 17.33-.22 27.33 0 68 0H50a342.94 342.94 0 00.92-35.86c-.23-8.15-.82-18.18-.92-34.94v-9.65c-6.25-.78-16.4-2.06-29-3.68-27.88-3.61-35.89-4.84-48.73-6-8.38-.74-21-1.64-36.78-1.84zM76.19 636.58a207 207 0 0134.48 7.35c14.32 4.36 26.55 8.09 40.45 17.47a112.44 112.44 0 0137.7 42.76c1.46 3 2.52 5.56 3.22 7.35l-106.2 4.91z",
    className: "coworking_before_svg__cls-19"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Auto_rot"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 525.35,
    cy: 860.01,
    r: 82.47,
    className: "coworking_before_svg__cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.45 801.36A59.53 59.53 0 10585 860.88a59.59 59.59 0 00-59.55-59.52zm44.7 42.1l-25 6.24a22.64 22.64 0 00-4.84-5.92 18.59 18.59 0 00-1.66-1.3l11.49-22.74a48.29 48.29 0 0120.01 23.72zm-92.35 23a49.73 49.73 0 01-.34-5.62 47.7 47.7 0 015.23-21.73L504 853.63a22.52 22.52 0 00-1.19 6.63zm62.7-51.17l-11.72 23.21a23.28 23.28 0 00-6.07-.07l-7.07-24.52a47.95 47.95 0 0124.86 1.42zm-34.91 1.89l7.18 24.93a22.5 22.5 0 00-3.11 2.53l-21.17-14.37a48.19 48.19 0 0117.1-13.05zm-25.4 59.58l24.81-6.15a22.46 22.46 0 004.4 6.22L497.7 900a48.17 48.17 0 01-17.51-23.2zm26.75 28.35l11.49-22.73a22.8 22.8 0 006.27 1.09l7.18 24.91a47 47 0 01-6.43.45 47.75 47.75 0 01-18.51-3.68zm35.21.72l-7.07-24.51a22.24 22.24 0 005-3.23l21.33 14.48a48.31 48.31 0 01-19.26 13.3zM567.5 884l-21.16-14.38a22.52 22.52 0 001.71-9.72l24.84-6.2a47.78 47.78 0 01-5.39 30.3z",
    className: "coworking_before_svg__cls-21"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1232.14,
    cy: 865.11,
    r: 82.47,
    className: "coworking_before_svg__cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.14 808.43a59.53 59.53 0 1059.52 59.57 59.6 59.6 0 00-59.52-59.57zm44.69 42.1l-25 6.25a22.29 22.29 0 00-4.83-5.93c-.54-.47-1.1-.89-1.66-1.3l11.49-22.74a48.27 48.27 0 0120 23.72zm-92.34 23a47.21 47.21 0 01-.34-5.61 47.73 47.73 0 015.22-21.74l21.32 14.48a22.58 22.58 0 00-1.19 6.63zm62.69-51.17l-11.71 23.18a22.51 22.51 0 00-6.08-.07l-7.07-24.47a47.95 47.95 0 0124.86 1.42zm-34.91 1.89l7.19 24.93a22.58 22.58 0 00-3.12 2.53l-21.16-14.37a48.36 48.36 0 0117.09-13.05zm-25.4 59.58l24.82-6.19a22.71 22.71 0 004.4 6.23l-11.7 23.16a48.17 48.17 0 01-17.52-23.16zm26.76 28.36l11.49-22.74a22.43 22.43 0 006.26 1.09l7.19 24.92a48.78 48.78 0 01-6.43.44 47.74 47.74 0 01-18.51-3.67zm35.21.71l-7.07-24.5a22.51 22.51 0 005-3.24l21.32 14.48a48.07 48.07 0 01-19.25 13.3zm25.35-21.9L1253 876.67a22.73 22.73 0 001.72-9.73l24.84-6.2a49.18 49.18 0 01.54 7.22 47.63 47.63 0 01-5.91 23.04z",
    className: "coworking_before_svg__cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M952.82 799.28c-.18-3.69-.43-9.79-.42-17.35 0-20.07 1.83-25.94-.43-38.12a82.24 82.24 0 00-5.78-18.42c-.61-1.34-4.33-7-11.78-18.41-2-3.09-3.69-5.56-6-5.57-2 0-2.63 1.78-7.07 6.21-4.22 4.21-5.17 4.14-8.78 8.14 0 0-2.19 2.43-4.28 5.35-2.48 3.47-6.56 10.23-10.49 23.34a146.54 146.54 0 00-5.36 26.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M932.48 694.13a6.1 6.1 0 003.21-.43c2.63-1.21 3.44-4.33 4.07-6.21 1.84-5.5 3.38-4.13 9.64-14.78 3-5 4.43-7.55 5.35-10.28 3.32-9.86.33-21.82-5.78-30.19-7.87-10.79-19.41-13.6-23.34-14.56-7.89-1.93-14.67-1.15-26.56.21a151.8 151.8 0 00-15.42 2.57 22.93 22.93 0 0110.28 5.54l-15.42.64a15.18 15.18 0 000 2.78c.68 7 6.31 11.47 7.29 12.21 6.25 4.76 10 1 14.77 4.5 7 5.16.55 14.66 8.14 28.48 2.76 5 6.48 8.28 13.92 14.78 1.29 1.15 5.01 4.33 9.85 4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.84 692a104.05 104.05 0 01-10.18 5.33l-.52.23c-4.81 2.16-9.12 3.78-13.71 3a6.41 6.41 0 01-2.78-1.28 11 11 0 01-3.86-5.36 29.08 29.08 0 01-1.31-14c0-.09.21-.55 0-.76a.55.55 0 00-.49-.1 8.93 8.93 0 01-3.53-.24 2.68 2.68 0 01-1.37-1.21 2.93 2.93 0 01-.08-2 6.65 6.65 0 011.29-2.57 10.4 10.4 0 001.4-2.19s.06-.23.16-.5.19-.5.2-.54a15.67 15.67 0 00.62-2.41 25.36 25.36 0 00.53-5 24.31 24.31 0 00-.85-4.82 25.14 25.14 0 01-.54-9.53 9.76 9.76 0 018.67-9.1c1.1-.24 6.92-1.36 10.5 2.14 1.07 1 1.51 2.14 2.35 4.28 2.24 5.69 1 7.36 2.79 11.78 1.27 3.14 4 7.47 7.06 7.49a3.33 3.33 0 002.15-.64c1-.79.79-1.84 1.92-4.49a5.37 5.37 0 011.07-1.93c1.28-1.1 3.61-1 5.14 0s2 2.7 2.36 4.28a15.32 15.32 0 01-.43 8.14c-.84 2.66-1.77 3.29-2.14 6a14.31 14.31 0 000 3.65c.56 4.75 2.56 9.35 3.85 12.63 3.07 7.75 4.89 12.5 2.79 15-.45.53-.72.54-2.63 1.45-5.11 2.42-5.39 3.37-10.11 5.78-1.75.89-8.53 4.34-9.48 3.05-.27-.37.07-1 .48-1.93a25.6 25.6 0 001.77-7.87c.59-4.89-.72-8.5-1.29-8.51-.11 0-3.73.44-4.09.4 0 0-2 .13-2 .11s.83.06-1.49-.07",
    className: "coworking_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M896.3 657.21a5 5 0 00-2.82-1.76 5.2 5.2 0 00-4.22 1.06"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 892.78,
    cy: 663.55,
    fill: "#fff",
    rx: 3.52,
    ry: 2.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 892.96,
    cy: 663.73,
    className: "coworking_before_svg__cls-3",
    rx: 1.23,
    ry: 1.76
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccb5",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M898.94 686a15.87 15.87 0 00-3.08-.13 17.39 17.39 0 00-8 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.34 662.54a4.41 4.41 0 00-1.6 1.61 5.28 5.28 0 00.16 4.81",
    className: "coworking_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.7,
    height: 47.38,
    x: 965.02,
    y: 638.51,
    className: "coworking_before_svg__cls-28",
    rx: 12.85,
    transform: "rotate(10.93 978.152 662.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.82,
    height: 70.69,
    x: 951.01,
    y: 686.13,
    className: "coworking_before_svg__cls-28",
    rx: 14.09,
    transform: "rotate(10.93 966.682 721.714)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.28 774c-4.57 0-12-2.34-18.55-15.11-4.36-8.51-7.48-19.95-8.76-32.22s-.63-24.12 1.87-33.34c4.16-15.35 12-18.4 16.37-18.85s12.66.89 19.91 15c4.37 8.5 7.48 20 8.76 32.22s.63 24.11-1.87 33.34c-4.16 15.34-12 18.4-16.36 18.85-.42.11-.88.11-1.37.11zm-7.68-85.76c-2.74 1-8.21 14.72-5.87 37s10.54 34.58 13.53 34.94c2.73-1 8.2-14.72 5.86-37s-10.54-34.55-13.52-34.91z",
    className: "coworking_before_svg__cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6e8ca6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.77,
    d: "M782.67 711.5c.88 2.27 1.7 4.07 2.21 5.16h28.72c36.91-.09 73.06-.17 115.61-1.47 16.34-.51 39.57-1.37 67.74-3 1-2.08 2.3-5.11 3.68-8.84a126 126 0 005.89-22.09c5.3-28.35 8-42.78 8.84-55.22.52-7.4.69-13.52.74-17.68-5.9.07-15.45.14-27.25 0-26.66-.3-33.87-1.27-52.28-.73-14.64.42-25.26 1.48-32.4 2.21-21.26 2.16-32.12 3.33-43.44 8.1-5.28 2.22-2.69 1.75-25.78 16.2-20.45 12.8-26.67 15.78-39.76 25a329.07 329.07 0 00-18.41 14c-.12 3.36-.07 6.1 0 7.95a94.93 94.93 0 005.89 30.41z",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b01928",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M1394.6 802.32c-2.78-4.93-9.63-7.78-17.34-7.2-.44-.36-1.13-.92-1.92-1.64-16-14.5-16.61-37.8-17.06-44.67-1.55-23.67-14.13-45-30.44-72.65-35.58-60.34-133.38-72.29-224.83-83.46-15.2-1.86-25.6-2.65-42.22-3.93 0 0-111.56-8.54-238.58 10.8a103.4 103.4 0 00-20.37 5.16 104.63 104.63 0 00-25 13.25c-23.55 16.65-49.84 29-74.37 44.18-30.61 18.92-49.08 29-60.56 34.83-1.18-.08-2.35-.16-3.5-.22-10.89-.53-20.48-.27-74.38 5.89-39.49 4.52-59.24 6.78-76.58 9.58-7.79 1.25-30 5.6-74.37 14.72 0 0-7.25 2-45.65 11.79a65.38 65.38 0 00-12.52 4.41 63.87 63.87 0 00-14.73 9.58c-10.06 8.94-13.27 21.64-16.2 33.87a146.35 146.35 0 00-3.68 42.71c.51 8.6 4.51 23.4 12.52 53a35.12 35.12 0 004.23 9.88 35.71 35.71 0 002.33 3.26c19.47 2.19 29.87 1 42.36.61a278.43 278.43 0 0039.26-3.92c4-.72 7.41-1.43 9.81-2a120.3 120.3 0 01.33-42.22c1.77-9.37 5.73-29.17 21.27-48.43a97.48 97.48 0 0127.48-23.5c28.1-15.62 56.14-11.16 65.78-9.49 9.48 1.65 29 5.29 47.12 20.95a91 91 0 0123.89 33.05c8 19.18 8.15 38.83 8.19 46.15 0 3.12-.08 13.26 1 27.16.24 3.21.49 5.84.65 7.53 12.54 2.66 456.42-.43 511.85 1.63.48-3.46.91-7 1.31-10.57 1.82-16.42 1.62-24.55 2.29-32.63.55-6.51 1.75-20.91 8.68-36a92.33 92.33 0 0126-32.72c6.76-5.39 22.59-17.69 45.66-19.64 30.06-2.54 52.11 14.2 61.85 21.6a108.23 108.23 0 0134.84 45.62 106.15 106.15 0 016.87 48.6c4.51-.66 8.11-1.17 10.31-1.47.21 0 7.43-1 37.14-7a13 13 0 006.55-2.94c2.47-2.25 3.32-5.18 4.58-11.13 1.45-6.87 2.24-12.08 2.29-12.43 1.3-8.61 1.46-7.23 4.91-26.84.73-4.17 1.3-7.52 1.64-9.49a4.49 4.49 0 001.63-1c.53-.5 1.35-1.56 1.47-4.26a17.08 17.08 0 00-1.79-8.36zm-379.22-176.24c-.88 12.45-3.54 26.88-8.84 55.23a126.2 126.2 0 01-5.89 22.09c-1.38 3.73-2.71 6.76-3.68 8.84-28.17 1.58-51.4 2.44-67.74 2.94-42.55 1.31-78.7 1.39-115.61 1.47H784.9c-.51-1.08-1.33-2.88-2.21-5.15a95.1 95.1 0 01-5.89-30.35c-.07-1.84-.12-4.59 0-7.94 3.86-3.15 10.22-8.2 18.41-14C808.3 650 814.52 647 835 634.18c23.09-14.44 20.49-14 25.78-16.2 11.32-4.76 22.18-5.94 43.44-8.1 7.14-.72 17.76-1.78 32.4-2.21 18.41-.53 25.62.44 52.28.74 11.8.13 21.35.07 27.25 0-.08 4.15-.25 10.28-.77 17.67z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.96,
    height: 30.46,
    x: 351.5,
    y: 766.46,
    fill: "#fcb042",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 13.92,
    transform: "rotate(2.88 379.286 781.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7d7e82",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M325.41 867.36A86.74 86.74 0 00337 892.21c.77 1.13 1.55 2.21 2.33 3.26 8.07.69 18.05 1.24 29.52 1.15 10.23-.08 17.67-.64 24.8-1.17 19.77-1.45 29.18-3.45 33.53-4.45 2.55-.59 4.62-1.14 6-1.51a141.22 141.22 0 01-2-21.67v-3.61c-3.24.31-7.89.75-13.5 1.23-9.42.81-18.24 1.64-26 2a312.55 312.55 0 01-40-.49c-10-.79-19.24-2-27.74-3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.47 703.32l10.14 3.11 7.2 1.47 4.58-2.95 15.06-11.78 41.89-28.47 57.6-38.62 25.52-15.38-7.2-2.29q-11.07-1.63-22.9-2.95c-3.85-.42-7.64-.79-11.38-1.14l-1.14.41a104.63 104.63 0 00-25 13.25c-23.55 16.65-49.84 29-74.37 44.18-30.61 18.92-49.08 29-60.56 34.83h3.94c12.66.24 26.71 2.8 36.62 6.33z",
    className: "coworking_before_svg__cls-33"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 639.04,
    x2: 1138.35,
    y1: 902.31,
    y2: 902.95,
    fill: "#b01928",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba1e2c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3.77,
    d: "M756.52 686.12c3.26-3.15 6.94-4 10-4.69 0 0 10.14-2.24 26.11 6.05a4.78 4.78 0 012 1.73c1.76 2.95-.89 7.45-1.35 8.23-3.11 5.29-8.77 7.23-12.82 8.62a34.67 34.67 0 01-11.23 1.84c-3 0-5.72 0-8.91-1.33-2-.83-7.14-2.93-8.55-7.8-1.77-6.15 3.84-11.77 4.75-12.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.68 632.46q-1.37 33.57-1.47 68.24v9.33c16.58-.63 30-.88 38.78-1 18.5-.23 29.18 0 72.65 0h13.75a367.25 367.25 0 001-38.28c-.24-8.71-.87-19.42-1-37.31v-10.31c-6.68-.83-17.52-2.2-30.93-3.93-29.77-3.85-38.32-5.17-52-6.38-9-.79-22.47-1.75-39.28-2zM1191.37 622.65a220 220 0 0136.82 7.85c15.29 4.65 28.35 8.63 43.2 18.65a120.19 120.19 0 0140.25 45.66c1.56 3.2 2.69 5.94 3.44 7.85l-113.4 5.24z",
    className: "coworking_before_svg__cls-33"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Stra\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.9,
    height: 23.62,
    x: 1.1,
    y: 960.57,
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.88,
    height: 23.62,
    x: 401.72,
    y: 960.57,
    className: "coworking_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200.88,
    height: 23.62,
    x: 802.89,
    y: 960.57,
    className: "coworking_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.48,
    height: 23.62,
    x: 1204.65,
    y: 960.57,
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.99
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Haus"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "329.28 523.1 329.28 -1 1259 -.99 1259 523.1 329.28 523.1",
    className: "coworking_before_svg__cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.28 0H1258v522.1H330.28V0m-2-2v526.1H1260V-2z",
    className: "coworking_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b27052",
    points: "867.34 93.78 1239.97 93.78 1239.97 522.31 867.34 523.1 867.34 93.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239 94.78v426.53l-370.63.79V94.78H1239m2-2H866.34V524.1l374.63-.79V92.78z",
    className: "coworking_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "902.21 119.93 1200.04 119.93 1200.04 522.31 902.21 523.1 902.21 119.93",
    className: "coworking_before_svg__cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199 120.93v400.39l-295.83.78V120.93H1199m2-2H901.21V524.1l299.83-.79V118.93z",
    className: "coworking_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 868.5,
    x2: 901.99,
    y1: 95.04,
    y2: 120.16,
    className: "coworking_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1238.63,
    x2: 1199.24,
    y1: 94.98,
    y2: 120.19,
    className: "coworking_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 187.96,
    height: 378.71,
    x: 959.67,
    y: 144.4,
    fill: "#7fc3ca",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1047.29 523.1 1047.29 426.3 959.68 426.3 959.68 413.56 1047.29 413.56 1047.29 326.47 959.68 326.47 959.68 313.73 1047.29 313.73 1047.29 228.15 959.67 228.15 959.67 215.41 1047.29 215.41 1047.28 144.41 1060 144.41 1060.02 215.41 1147.63 215.41 1147.63 228.15 1060.02 228.15 1060.02 313.73 1147.63 313.73 1147.63 316.36 1147.64 316.36 1147.64 324.78 1147.63 326.47 1060.02 326.47 1060.02 413.56 1147.63 413.56 1147.63 426.3 1060.02 426.3 1060.01 523.1 1047.29 523.1",
    className: "coworking_before_svg__cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059 145.41v71h87.61v10.74H1059v87.58h87.62v10.69H1059v89.09h87.62v10.79H1059v96.8h-10.72v-96.8h-87.6v-10.74h87.61v-89.09h-87.61v-10.74h87.61v-87.58h-87.61v-10.74h87.61v-71H1059m2-2h-14.72v71h-87.6v14.74h87.61v83.58h-87.61v14.74h87.61v85.09h-87.61v14.74h87.61v96.8H1061v-96.8h87.62v-14.74H1061v-85.09h87.62V312.73H1061v-83.58h87.61v-14.74H1061v-71z",
    className: "coworking_before_svg__cls-3"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Uhr"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M629.38 80.27a64.26 64.26 0 1022.72 124.37V84.41a64.15 64.15 0 00-22.72-4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 205.69A61.17 61.17 0 11652.1 87.75v-6.62a67.35 67.35 0 100 126.78v-6.61a60.91 60.91 0 01-22.72 4.39z",
    className: "coworking_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.18,
    x2: 629.18,
    y1: 80.27,
    y2: 90.3,
    className: "coworking_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.18 93.39a3.09 3.09 0 01-3.08-3.09v-10a3.09 3.09 0 116.17 0v10a3.09 3.09 0 01-3.09 3.09z",
    className: "coworking_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 565.12,
    x2: 575.15,
    y1: 144.2,
    y2: 144.22,
    className: "coworking_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.15 147.31h-10a3.09 3.09 0 010-6.17h10a3.09 3.09 0 110 6.17z",
    className: "coworking_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629.06,
    x2: 629.08,
    y1: 208.4,
    y2: 198.36,
    className: "coworking_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.06 211.48a3.08 3.08 0 01-3.08-3.09v-10a3.09 3.09 0 013.09-3.09 3.09 3.09 0 013.08 3.1v10a3.07 3.07 0 01-3.09 3.08z",
    className: "coworking_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.38 189a1.74 1.74 0 01-1.74-1.74v-40.88a1.74 1.74 0 013.47 0v40.91a1.73 1.73 0 01-1.73 1.71z",
    className: "coworking_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 144.11c-.83-.49-1.75-.46-2.06.07l-13 22.26c-.31.52.12 1.34.94 1.82s1.75.46 2.06-.07l13-22.26c.33-.52-.1-1.34-.94-1.82z",
    className: "coworking_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 629.18,
    cy: 144.33,
    r: 3.09,
    className: "coworking_before_svg__cls-46"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.62,
    height: 78.81,
    x: 570.14,
    y: 312.06,
    className: "coworking_before_svg__cls-47",
    rx: 9.46
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.53,
    height: 77.01,
    x: 440.5,
    y: 297,
    className: "coworking_before_svg__cls-47",
    rx: 6.27
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "coworking_before_svg__Fenster",
    width: 232.43,
    height: 292.65,
    x: 420.18,
    y: 65.88,
    fill: "#7fc3ca",
    opacity: 0.52
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Wand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.28 523.1V-1h412.59v524.1zm92-165h230.2V67H421.31z",
    className: "coworking_before_svg__cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.28 0h410.59v522.1H330.28V0m90 359.15h232.2V66H420.31v293.15M328.28-2v526.1h414.59V-2zm94 359.15V68h228.2v289.15z",
    className: "coworking_before_svg__cls-3"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.92 554h-3.09c-18.15 0-32.92-9.37-32.92-20.9 0-9.42 9.8-17.53 23.75-20.07-3.72-3.45-5.73-7.55-5.73-11.8 0-9.42 9.66-17.5 23.71-20.07a13.26 13.26 0 01-.61-3.95c0-10.21 11.2-18.71 26.84-20.53.92-11 15.31-19.78 32.86-19.78a52 52 0 018.88.76c6.12-5.69 16.2-9.07 27.15-9.07a47.64 47.64 0 0117.55 3.2c5.63-5 14.6-8.2 24.33-8.66 6.1-5.85 16.29-9.32 27.42-9.32 17.67 0 32.14 8.89 32.88 20 11.17 1.75 20.18 7.18 23.52 14.17 15.81 0 29 6.94 32.15 16.63 15.64.23 28.6 7.22 31.5 16.91 13.12 2.94 21.88 10.78 21.88 19.7 0 5-2.65 9.61-7.52 13.33 10.84 3.45 17.68 10.55 17.68 18.45 0 9.52-10.12 17.84-24.6 20.21h-.11l-295.92.67a15.85 15.85 0 01-1.6.12z",
    className: "coworking_before_svg__cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.06 415.23c17.34 0 31.41 8.68 31.41 19.4v.41c11.85 1.52 21.22 7.17 24.06 14.4h.92c15.83 0 28.89 7.24 31.06 16.64h.35c15.86 0 28.93 7.26 31.07 16.69 12.54 2.54 21.6 9.82 21.6 18.42 0 5.45-3.65 10.36-9.51 13.89 11.53 2.87 19.67 9.83 19.67 18 0 9-9.91 16.53-23.34 18.73l-295.86.67c-.52.05-1 .07-1.53.07-1 0-2-.07-3.09-.07-17.35 0-31.42-8.68-31.42-19.4 0-9.54 11.17-17.46 25.86-19.08-4.86-3.42-7.84-7.88-7.84-12.79 0-9.19 10.36-16.87 24.25-18.88a12.59 12.59 0 01-1.15-5.14c0-9.75 11.65-17.8 26.81-19.17v-.24c0-10.71 14.06-19.4 31.41-19.4a49.56 49.56 0 019.36.88c5.54-5.51 15.4-9.19 26.67-9.19a45.87 45.87 0 0117.87 3.45c5.26-5.1 14.27-8.57 24.65-8.94 5.52-5.57 15.43-9.29 26.78-9.29m0-3c-11.26 0-21.63 3.47-28.05 9.35-9.59.54-18.17 3.56-24 8.4a49.63 49.63 0 00-17.25-3c-11 0-21.18 3.33-27.62 9a53.12 53.12 0 00-8.41-.67c-18 0-32.39 8.58-34.21 19.94-15.79 2.21-27 11.15-27 21.87a14.65 14.65 0 00.27 2.79c-13.92 3-23.37 11.43-23.37 21.23a16.76 16.76 0 004.23 10.8c-13.23 3.2-22.3 11.46-22.3 21 0 12.56 15.12 22.4 34.42 22.4h3.09c.6 0 1.15 0 1.66-.07l295.74-.67h.48c15.22-2.5 25.85-11.42 25.85-21.69 0-7.95-6.21-15.06-16.23-19.07 3.95-3.69 6.07-8.11 6.07-12.8 0-9.45-8.86-17.73-22.22-21-3.48-9.65-16.22-16.59-31.6-17.11-3.79-9.58-16.79-16.38-32.28-16.65-3.72-6.87-12.24-12-23.08-14-1.63-11.5-16.09-20.22-34.25-20.22z",
    className: "coworking_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "coworking_before_svg__cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.41 542c0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.79 0-9.19 10.36-16.88 24.25-18.88a12.6 12.6 0 01-1.15-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.71 14.07-19.4 31.41-19.4a49.48 49.48 0 019.36.88c5.54-5.51 15.4-9.19 26.68-9.19a45.78 45.78 0 0117.86 3.45c5.27-5.1 14.28-8.57 24.65-8.94 5.52-5.57 15.43-9.3 26.78-9.3a47.43 47.43 0 0114.44 2.19c-5-6.61-15.84-11.19-28.44-11.19-11.34 0-21.25 3.72-26.77 9.29-10.37.37-19.39 3.84-24.65 8.94a45.83 45.83 0 00-17.89-3.43c-11.27 0-21.13 3.68-26.67 9.19a49.56 49.56 0 00-9.36-.88c-17.34 0-31.41 8.69-31.41 19.4v.24c-15.16 1.37-26.81 9.42-26.81 19.17a12.59 12.59 0 001.15 5.14c-13.89 2-24.25 9.69-24.25 18.88 0 4.91 3 9.37 7.84 12.79-14.69 1.62-25.86 9.54-25.86 19.08 0 7.5 6.9 14 17 17.22a13.55 13.55 0 01-2.98-8.23z",
    className: "coworking_before_svg__cls-12"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "coworking_before_svg__Busch-2",
    "data-name": "Busch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1157.14 570.52h-3.09c-18.15 0-32.91-9.37-32.91-20.9 0-9.42 9.79-17.53 23.74-20.07-3.72-3.45-5.73-7.55-5.73-11.8 0-9.42 9.66-17.51 23.71-20.07a13.28 13.28 0 01-.61-4c0-10.2 11.21-18.7 26.84-20.52.92-11 15.31-19.78 32.86-19.78a52 52 0 018.88.76C1237 448.42 1247 445 1258 445a47.58 47.58 0 0117.54 3.2c5.63-5 14.6-8.21 24.33-8.66 6.1-5.85 16.29-9.33 27.42-9.33 17.68 0 32.14 8.9 32.88 20 11.17 1.75 20.18 7.19 23.52 14.18 15.81 0 29 6.93 32.15 16.63 15.65.23 28.61 7.22 31.5 16.91 13.13 2.94 21.88 10.78 21.88 19.7 0 5-2.65 9.61-7.51 13.33 10.84 3.56 17.67 10.62 17.67 18.54 0 9.52-10.11 17.83-24.59 20.21h-.12l-295.92.67a15.85 15.85 0 01-1.61.14z",
    className: "coworking_before_svg__cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.28 431.75c17.35 0 31.41 8.69 31.41 19.41v.41c11.84 1.52 21.21 7.17 24 14.4h.92c15.83 0 28.89 7.23 31.06 16.64h.36c15.85 0 28.92 7.26 31.07 16.68 12.53 2.55 21.59 9.83 21.59 18.43 0 5.44-3.65 10.36-9.5 13.88 11.52 2.88 19.66 9.84 19.66 18 0 9-9.91 16.53-23.34 18.73l-295.86.67c-.52 0-1 .07-1.53.07-1 0-2-.07-3.09-.07-17.35 0-31.41-8.69-31.41-19.4 0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.79 0-9.2 10.36-16.88 24.25-18.88a12.6 12.6 0 01-1.15-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.71 14.07-19.4 31.41-19.4a49.48 49.48 0 019.36.88c5.54-5.51 15.4-9.19 26.68-9.19a45.78 45.78 0 0117.86 3.45c5.27-5.1 14.28-8.57 24.65-8.94 5.52-5.57 15.43-9.3 26.78-9.3m0-3c-11.26 0-21.63 3.48-28 9.36-9.6.54-18.17 3.55-24 8.4a49.72 49.72 0 00-17.25-3c-11 0-21.19 3.33-27.63 9a53 53 0 00-8.41-.66c-18 0-32.38 8.58-34.21 19.94-15.79 2.21-27 11.15-27 21.86a14.75 14.75 0 00.27 2.8c-13.92 3-23.37 11.43-23.37 21.23a16.78 16.78 0 004.28 10.89c-13.23 3.2-22.29 11.45-22.29 21 0 12.56 15.11 22.4 34.41 22.4h3.09c.53 0 1.15 0 1.66-.07l295.74-.67h.48c15.22-2.5 25.85-11.42 25.85-21.69 0-7.95-6.2-15.07-16.23-19.07 3.95-3.7 6.07-8.11 6.07-12.8 0-9.45-8.86-17.73-22.22-21-3.48-9.66-16.22-16.59-31.6-17.11-3.79-9.58-16.78-16.38-32.28-16.65-3.72-6.87-12.24-12-23.07-14-1.64-11.5-16.1-20.22-34.26-20.22z",
    className: "coworking_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "coworking_before_svg__cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1136.63 558.56c0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.8 0-9.19 10.36-16.87 24.25-18.87a12.6 12.6 0 01-1.15-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.72 14.07-19.4 31.42-19.4a50.22 50.22 0 019.35.87c5.54-5.51 15.4-9.19 26.68-9.19a45.6 45.6 0 0117.86 3.46c5.27-5.11 14.28-8.57 24.65-8.94 5.52-5.57 15.43-9.3 26.78-9.3a47.75 47.75 0 0114.44 2.18c-5-6.6-15.84-11.19-28.43-11.19-11.35 0-21.26 3.73-26.78 9.3-10.37.37-19.38 3.84-24.65 8.94a45.78 45.78 0 00-17.86-3.45c-11.28 0-21.14 3.68-26.68 9.19a49.48 49.48 0 00-9.36-.88c-17.34 0-31.41 8.69-31.41 19.4v.23c-15.16 1.38-26.81 9.43-26.81 19.17a12.6 12.6 0 001.15 5.15c-13.89 2-24.25 9.68-24.25 18.88 0 4.9 3 9.37 7.84 12.79-14.69 1.62-25.85 9.54-25.85 19.08 0 7.5 6.89 14 17 17.22a13.55 13.55 0 01-3.01-8.21z",
    className: "coworking_before_svg__cls-12"
  })))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "523.5 358.14 523.5 225.39 421.3 225.39 421.3 199.63 523.5 199.63 523.5 66.87 549.28 66.87 549.28 199.63 651.48 199.63 651.48 225.39 549.28 225.39 549.28 358.14 523.5 358.14",
    className: "coworking_before_svg__cls-39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M548.28 67.87v132.76h102.2v23.76h-102.2v132.76h-23.77V224.39H422.3v-23.76h102.21V67.87h23.77m2-2h-27.77v132.76H420.3v27.76h102.21v132.75h27.77V226.39h102.2v-27.76h-102.2V65.87z",
    className: "coworking_before_svg__cls-3"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoworkingbefore);
export default __webpack_public_path__ + "static/media/coworking.before.3ebaf6ac.svg";
export { ForwardRef as ReactComponent };